import { useCallback, useState } from "react";
import { useNavigate } from "react-router";

import type { ChillnnStudioDriver } from "@/lib/chillnn-studio-driver";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import type { ComponentProps } from "react";

type ChillnnStudioDriverProps = ComponentProps<typeof ChillnnStudioDriver>;

type Props = {
	/**
	 * saveAndExitの際に遷移するページのパス
	 */
	pagePathAfterSaveAndExit: string;

	editorProps: ChillnnStudioDriverProps["editorProps"];

	shouldTransitionBlockStatusMethods: {
		shouldTransitionBlockStatus: boolean;
		activateTransitionBlockStatus: () => void;
		deactivateTransitionBlockStatus: () => void;
	};
};

type UseDesignSnackEditUUIDSnackType = {
	isShowBaseSettingDialog: boolean;
	handleClickBaseSettingSaveButton: () => void;

	editorProps: ChillnnStudioDriverProps["editorProps"];
};

export const useSnackAndHPBSnackCreateNewItem = ({
	editorProps,
	pagePathAfterSaveAndExit,
	shouldTransitionBlockStatusMethods,
}: Props): UseDesignSnackEditUUIDSnackType => {
	const { shouldTransitionBlockStatus, deactivateTransitionBlockStatus } = shouldTransitionBlockStatusMethods;

	useTransitionBlock(shouldTransitionBlockStatus);

	// 新規作成の場合、初期描画時にはダイアログを表示する（初期値：true）
	const [isShowBaseSettingDialog, setIsShowBaseSettingDialog] = useState(true);
	const { callbackSave: _callbackSave, callbackSaveAndExit: _callbackSaveAndExit } = editorProps;

	const navigate = useNavigate();

	const callbackSaveAndExit = useCallback(async () => {
		deactivateTransitionBlockStatus();

		await _callbackSaveAndExit();

		navigate(pagePathAfterSaveAndExit);
	}, [_callbackSaveAndExit, deactivateTransitionBlockStatus, navigate, pagePathAfterSaveAndExit]);

	const handleClickBaseSettingSaveButton = useCallback(() => {
		setIsShowBaseSettingDialog(false);
	}, []);

	const callbackSave = useCallback(async () => {
		deactivateTransitionBlockStatus();
		await _callbackSave();
	}, [_callbackSave, deactivateTransitionBlockStatus]);

	return {
		isShowBaseSettingDialog,
		handleClickBaseSettingSaveButton,

		editorProps: {
			...editorProps,
			callbackSaveAndExit,
			callbackSave,
		},
	};
};
